"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const FeatureFlag = ({ flags, renderOff, authorizedFlags, children }) => {
    const matchingFlags = flags.filter(flag => {
        return authorizedFlags.find(authorizedFlag => flag === authorizedFlag);
    });
    if (matchingFlags.length && children)
        return (0, jsx_runtime_1.jsx)(React.Fragment, { children: children });
    if (renderOff)
        return (0, jsx_runtime_1.jsx)(React.Fragment, { children: renderOff });
    return null;
};
exports.default = FeatureFlag;
//# sourceMappingURL=FeatureFlag.js.map